"use client";
/*
 * Documentation:
 * OW_Topic_Hero — https://app.subframe.com/4f62853ee923/library?component=OW_Topic_Hero_ebb3a23a-904f-4290-96bd-43d93cf94953
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Ow_Topic_HeroRootProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

const Ow_Topic_HeroRoot = React.forwardRef<
  HTMLDivElement,
  Ow_Topic_HeroRootProps
>(function Ow_Topic_HeroRoot(
  { title, description, className, ...otherProps }: Ow_Topic_HeroRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full flex-col items-center justify-center rounded-t-md px-4 py-32 mobile:px-4 mobile:py-16",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex max-w-[768px] flex-col items-center justify-center gap-6">
        {title ? (
          <span className="text-heading-1 font-heading-1 text-neutral-900">
            {title}
          </span>
        ) : null}
        {description ? (
          <span className="text-body font-body text-neutral-900 text-center">
            {description}
          </span>
        ) : null}
      </div>
    </div>
  );
});

export const Ow_Topic_Hero = Ow_Topic_HeroRoot;
